<template>
  <div class="login ">
    <section class="hero is-white is-small">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-2">
            Helferanmeldung Musikwelle Guggach 2019
          </h1>
          <h2 class="subtitle">

          </h2>
        </div>
      </div>
    </section>

    <div class="columns is-centered">
      <div class="column   is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
        <input
          class="input is-medium"
          type="text"
          v-model="email"
          placeholder="Email"
        ><br>
        <input
          class="input is-medium"
          type="password"
          v-model="password"
          placeholder="Password"
        ><br>
        <button
          class="button is-link"
          v-on:click="signIn"
        >Anmelden</button>
      </div>
    </div>
    <br>
    <button
      class="button is-warning"
      v-on:click="sendMail"
    >Passwort vergessen?</button>
    <br>
    <h3 class="title is-3">Du bist noch nicht angemeldet?
      <router-link to="/sign-up">Registriere dich hier</router-link>
    </h3>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from "firebase";

export default {
  name: "login",
  data: function () {
    return {
      email: "",
      password: ""
    };
  },
  created () {
    this.checkLogin()
  },
  methods: {
    signIn: function () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password).catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          alert(errorMessage)

          // ...
        })
        .then(
          user => {
            this.$router.replace("hello");
          },
          err => {
            alert("Oops. " + err.message);
          }
        )
    },

    checkLogin: function () {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        console.log("angemeldet")
        this.$router.replace("hello");
      } else console.log("zuerst anmelden"); return

    },

    sendMail: function () {
      firebase.auth().sendPasswordResetEmail(this.email).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage + "     Du musst oben deine Mailadresse eingeben")
      })
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  /* width: 20%; */
  padding: 15px;
}
button {
  margin-top: 20px;
  /* width: 10%; */
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>
